import { AxiosInstance } from "axios";
import { IEmailMounted } from "src/services/interface/emails/IEmailMounted";
import { IRender } from "src/services/interface/emails/IRender";
import IBaseResponse from "src/services/interface/IBaseResponse";
import { ApiService } from "src/services/model/Api.model";
import { generateQueryString } from "src/util/helper";

enum MountedEmailServiceEnum {
  getTriggers = "/get-triggers",
  getAttachmentCategories = "/get-attachment-categories",
  getAttachmentSources = "/get-attachment-sources",
  getAllTemplatesEmail = "/get-all",
  getTemplateById = "/get-by-id",
  saveOrUpdateTemplateEmail = "/save-or-update",
  deleteTemplateEmail = "/delete",
  render = "/render"
}

export default class MountedEmailService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/mounted-email");
  }

  public getTriggers = async (): Promise<string[]> => await this.GET(MountedEmailServiceEnum.getTriggers);
  public getAttachmentCategories = async (): Promise<string[]> => await this.GET(MountedEmailServiceEnum.getAttachmentCategories);
  public getAttachmentSources = async (): Promise<string[]> => await this.GET(MountedEmailServiceEnum.getAttachmentSources);
  public getAllTemplates = async (): Promise<IEmailMounted[]> => await this.GET(MountedEmailServiceEnum.getAllTemplatesEmail);
  public getTemplateById = async (id: number): Promise<IEmailMounted> => await this.GET(`${MountedEmailServiceEnum.getTemplateById}?${generateQueryString({ id })}`);
  public saveOrUpdateTemplateEmail = async (mountedEmail: IEmailMounted | Omit<IEmailMounted, "id">): Promise<void> =>
    await this.POST(MountedEmailServiceEnum.saveOrUpdateTemplateEmail, mountedEmail);
  public deleteTemplateEmail = async (mountedEmail: IEmailMounted): Promise<void> => await this.POST(MountedEmailServiceEnum.deleteTemplateEmail, mountedEmail);
  public render = async (render: IRender): Promise<IBaseResponse> => await this.POST(MountedEmailServiceEnum.render, render)
}



// WEBPACK FOOTER //
// ./src/services/api/email/MountedEmail.service.ts